import { InsuranceTypesMappedToFormTypes } from '../definitions/CurrentDocument';

/**
 * Gets the form type from the list of insurance types
 * @param {String} insuranceType
 * @returns {String} The form type. standard, disability, or group
 */
export default function getFormTypeFromInsuranceType(insuranceType) {
    return Object.entries(InsuranceTypesMappedToFormTypes)
        // Look through the different insurance types for a match
        .find(([ _key, value ]) => value.includes(insuranceType)) // eslint-disable-line no-unused-vars
        // Return undefined or the key
        ?.[0].toLowerCase();
}